document.addEventListener('DOMContentLoaded', () => {

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initColorizerSliders = () => jQuery(".model-vehicle-colorizer").not('.slick-initialized').each(function () {
    const slider = this;
    const img = slider.querySelector('img');
    const init = () => jQuery(slider).not('.slick-initialized').slick({
     "dots": false,
     "fade": true,
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
     "infinite": true,
     "speed": 500,
     "slidesToShow": 1,
     "slidesToScroll": 1,
     "initialSlide": 0
   });
    if (!img || img.complete) {
      init();
      return;
    }
    slider.classList.add('is-loading');
    const ready = () => {
      slider.classList.remove('is-loading');
      init();
      slider.classList.add('is-loaded');
      setTimeout(() => slider.classList.remove('is-loaded'), 700);
    };
    img.addEventListener('load', ready, { once: true });
    img.addEventListener('error', ready, { once: true });
  });
  setTimeout(initColorizerSliders, 0);

  const updateColorRow = (row) => {
    const max = row.scrollWidth - row.clientWidth;
    row.classList.toggle('is-scrollable', max > 1);
    row.classList.toggle('is-start', row.scrollLeft <= 1);
    row.classList.toggle('is-end', row.scrollLeft >= max - 1);
  };
  const colorRows = document.querySelectorAll('.lbx-color-row');
  let finishColorSwap = null;
  colorRows.forEach((row) => {
    updateColorRow(row);
    row.addEventListener('scroll', () => updateColorRow(row), { passive: true });
  });

  // GET THE INDEX OF THE SLIDE BEFORE THE CHANGE
  jQuery('.model-vehicle-colorizer').on('beforeChange', function(e, s, currentSlideIndex, nextSlide) {
    jQuery(`div[id!='${s.$slider[0].id}'].model-vehicle-colorizer`).slick('unslick');
    jQuery(`div[id!='${s.$slider[0].id}'].model-vehicle-colorizer`).slick({
      "dots": false,
      "fade": true,
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
      "infinite": true,
      "speed": 500,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "initialSlide": nextSlide
    });
});

  const btnColor = document.querySelectorAll('.div-colors .btn-color.cursor-pointer');
  btnColor.forEach(btn => {
    btn.addEventListener('click', () => {
      let selectedFilter = btn.getAttribute('data-filter');
      let colorName = btn.getAttribute('data-colorName');
      
      selectedFilter = selectedFilter.split('|')[1];
      jQuery('.color-name').html(colorName);
      document.querySelectorAll('.color-name').forEach((el) => {
        el.classList.remove('lbx-name-in');
        void el.offsetWidth;
        el.classList.add('lbx-name-in');
      });
      let hexColor = btn.getAttribute('data-filter').split('|')[2];
      jQuery("#stop-color-colorizer").attr("stop-color",hexColor);

      let itemsToHide = document.querySelectorAll(`.colorizer-section .colorizer-image-container:not([data-filter='${selectedFilter}'])`);
      let itemsToShow = document.querySelectorAll(`.colorizer-section [data-filter='${selectedFilter}']`);
      /* document.querySelector('.color-name').innerHTML = colorName; */

      btnColor.forEach((item) => item.setAttribute('aria-pressed', String(item.getAttribute('data-filter') === btn.getAttribute('data-filter'))));
      jQuery(`.round-color`).removeClass("active");
      jQuery(`[data-filter='round|${selectedFilter}']`).addClass("active");
      
      // Adding Checkmarks
      jQuery(`.colorizer-checkmark`).removeClass("check-active");
      jQuery(`[data-filter='checkmark|${selectedFilter}']`).addClass("check-active animated");

      if (finishColorSwap) finishColorSwap();
      const leaving = reduceMotion.matches ? [] : [...itemsToHide].filter((el) => el.offsetParent !== null);
      const lifted = [];

      itemsToHide.forEach(el => {
        if (leaving.includes(el)) return;
        el.classList.add('hidden');
        el.classList.remove('block');
      });

      leaving.forEach((el) => {
        if (getComputedStyle(el.parentElement).position === 'static') {
          el.parentElement.style.position = 'relative';
          lifted.push(el.parentElement);
        }
        el.classList.add('lbx-color-leaving');
      });
      
      itemsToShow.forEach(el => {
        el.classList.remove('hidden');
        el.classList.add('block');
        if (leaving.length) el.classList.add('lbx-color-entering');
        //el.style.background = `linear-gradient(45deg, ${hexColor} 0, white 100%)`;
      });
      
      jQuery('.model-vehicle-colorizer.slick-initialized').slick('refresh');

      if (leaving.length) {
        let timer = 0;
        finishColorSwap = () => {
          clearTimeout(timer);
          leaving.forEach((el) => {
            el.classList.add('hidden');
            el.classList.remove('block', 'lbx-color-leaving');
          });
          itemsToShow.forEach((el) => el.classList.remove('lbx-color-entering'));
          lifted.forEach((el) => el.style.removeProperty('position'));
          finishColorSwap = null;
        };
        timer = setTimeout(finishColorSwap, 480);
      }
    })
  })

  let colorizerWidth = window.innerWidth;
  let colorizerResize = 0;
  window.addEventListener('resize', function() {
    if (window.innerWidth === colorizerWidth) return;
    colorizerWidth = window.innerWidth;
    clearTimeout(colorizerResize);
    colorizerResize = setTimeout(() => {
      jQuery('.model-vehicle-colorizer.slick-initialized').slick('refresh');
      colorRows.forEach(updateColorRow);
    }, 150);
  });

  /* 
  const btnReserve = document.querySelectorAll('.cta-reservenow');
  btnReserve.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let leadInfo='&extradata=';

      let condition = document.querySelectorAll('.value__condition');  
      condition.forEach(lbl => {
        leadInfo+='Condition: ' + lbl.innerText + ' ';
      });

      const btnColors = document.querySelectorAll('.round-color.active');
      const color = btnColors[0] ? btnColors[0].closest('.btn-color') : null;
      if (color)
        leadInfo+='- Color: ' + color.getAttribute('data-colorname') + ' ';

      const leadFrequency = document.querySelectorAll('.leadFrequency'); 
      let frequency = "";
      leadFrequency.forEach(freq=>{
        if(freq.classList.contains('weekly')) frequency = 'Weekly';
        if(freq.classList.contains('bi-weekly')) frequency = 'Bi-Weekly';
        if(freq.classList.contains('monthly')) frequency = 'Monthly';
      })

      if (frequency != '')
        leadInfo+='- Frequency: ' + frequency + ' ';

      const leadData = document.querySelectorAll('.infoLead');
      leadData.forEach(inpt => {
        leadInfo += `- ${inpt.getAttribute('data-key')}: ` + `${inpt.value}` + ' ';
      })

      const leadLabels = document.querySelectorAll('.labelLead');
      leadLabels.forEach(lbl => {
        leadInfo+=`- ${lbl.getAttribute('data-key')}: ` + `${lbl.innerText}` + ' ';
      })

      const leadCheck = document.querySelectorAll('.checkLead');
      leadCheck.forEach(chk=>{
        leadInfo+=`- ${chk.getAttribute('data-key')}: ` + ((chk.checked)?'true':'false') + ' ';
      })

      const hrefValue = e.target.getAttribute('href')+leadInfo;

      window.location.href = hrefValue;
    })
  });
  */
});